/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateEmailValidationCodeRequest
 */
export interface ValidateEmailValidationCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof ValidateEmailValidationCodeRequest
     */
    validationCode: string;
}

/**
 * Check if a given object implements the ValidateEmailValidationCodeRequest interface.
 */
export function instanceOfValidateEmailValidationCodeRequest(value: object): value is ValidateEmailValidationCodeRequest {
    if (!('validationCode' in value) || value['validationCode'] === undefined) return false;
    return true;
}

export function ValidateEmailValidationCodeRequestFromJSON(json: any): ValidateEmailValidationCodeRequest {
    return ValidateEmailValidationCodeRequestFromJSONTyped(json, false);
}

export function ValidateEmailValidationCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateEmailValidationCodeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'validationCode': json['validationCode'],
    };
}

export function ValidateEmailValidationCodeRequestToJSON(value?: ValidateEmailValidationCodeRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'validationCode': value['validationCode'],
    };
}

